import React from 'react';
import { Text, TextTooltip } from 'library/ui';
import { InfoRounded } from '@mui/icons-material';

export default function CardInfo({
    title = '',
    content,
    infoText,
    bodyTextBold = true,
    titleTextBold = false,
}: {
    title?: string;
    content: string;
    infoText?: string;
    bodyTextBold?: boolean;
    titleTextBold?: boolean;
}) {
    return (
        <Text size="xs" weight={titleTextBold ? 'bold' : 'regular'}>
            {title}{' '}
            <Text size="sm" weight={bodyTextBold ? 'bold' : 'regular'}>
                {content}
                {infoText ? (
                    <TextTooltip title={infoText}>
                        <InfoRounded fontSize="small" sx={{ marginTop: '-4px' }} />
                    </TextTooltip>
                ) : (
                    ''
                )}
            </Text>
        </Text>
    );
}
